<template>

<button
	class="btn"
	:class="['is-' + kind, { 'is-block': block, 'is-loading': loading }]"
	:disabled="disabled || loading"
	:type="type"
	v-on:click="$emit('click', $event)"
>
	<slot></slot>
</button>

</template>

<script>

/*
	The boxart button: light editorial, NOT tally's hard-shadow mono caps.
	- primary: solid ink fill, paper text (the "Guess" button).
	- ghost:   hairline border on paper, ink text (secondary actions).
	8px radius, IBM Plex Sans, a soft accent focus ring. `loading` holds the
	button while an API call is in flight; clicks are ignored.
*/

export default {

	props: {
		kind: {
			default: 'primary'
		},
		block: {
			type: Boolean,
			default: false
		},
		disabled: {
			type: Boolean,
			default: false
		},
		loading: {
			type: Boolean,
			default: false
		},
		type: {
			default: 'button'
		}
	}

}

</script>

<style scoped>

.btn {
	font-family: var(--font-body);
	font-size: 15px;
	font-weight: 600;
	height: 48px;
	padding: 0 20px;
	border: 1px solid transparent;
	border-radius: var(--radius);
	box-sizing: border-box;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	white-space: nowrap;
	cursor: pointer;
	transition: background 140ms ease, box-shadow 140ms ease, opacity 140ms ease;
}

.btn.is-block {
	width: 100%;
}

.btn.is-primary {
	background: var(--ink);
	color: var(--paper);
}

.btn.is-primary:hover:not(:disabled) {
	background: #2c2922;
}

.btn.is-ghost {
	background: #fff;
	color: var(--ink);
	border-color: var(--tile);
}

.btn.is-ghost:hover:not(:disabled) {
	border-color: var(--muted-2);
}

.btn:focus-visible {
	outline: none;
	box-shadow: 0 0 0 3px rgba(63, 93, 138, 0.28);
}

.btn:disabled {
	opacity: 0.5;
	cursor: default;
}

.btn.is-loading {
	cursor: progress;
	opacity: 0.7;
}

</style>
